import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import ClienteForm from '../components/ClienteForm';
import { maskCPF, maskCNPJ, limparCpfCnpj } from '../utils/Masker';
import { getUsuario, getTemPermissao, getTipoUsuario } from "../utils/LoginManager";
import moment from "moment-timezone";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
  };

  componentDidMount() {
    const usuario = getUsuario();
    getTipoUsuario().then(tipoUsuario => {
      this.setState({
        tipoUsuario,
        usuario,
      },
        this.getListaRegistros()
      );
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/pessoas', {
        params: {
          page: pagina,
          limite: limite,
          nome: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.pes_idf) { //editar      
      request = axios.put(`/pessoas/update/${registro.pes_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/pessoas/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Cliente gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        console.log('end', error.response.data.pes_endereco);
        this.setState({ salvando: false })
        if ((error.response) && (error.response.status === 412)) {
          if (error.response.data.pes_cpf_cnpj) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_cpf_cnpj, okText: 'OK', })
          } else if (error.response.data.pes_nome) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_nome, okText: 'OK', })
          } else if (error.response.data.pes_razao_social) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_razao_social, okText: 'OK', })
          } else if (error.response.data.pes_inscr_est) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_inscr_est, okText: 'OK', })
          } else if (error.response.data.pes_endereco) {
            if ((error.response.data.pes_endereco[0]) && (error.response.data.pes_endereco[0] === 'validation.min.string')) {
              Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. Digite um Endereço Válido', okText: 'OK', })
            } else {
              Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_endereco, okText: 'OK', })
            }
          } else if (error.response.data.pes_numero) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_numero, okText: 'OK', })
          } else if (error.response.data.pes_bairro) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_bairro, okText: 'OK', })
          } else if (error.response.data.pes_cep) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_cep, okText: 'OK', })
          } else if (error.response.data.pes_fone1) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_fone1, okText: 'OK', })
          } else if (error.response.data.pes_email) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.pes_email, okText: 'OK', })
          }
        } else {
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/pessoas/show/${registro.pes_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.pes_municipio = {
          key: String(data.dados.pes_municipio),
          label: data.dados.cmun_descricao,
          cmun_uf: String(data.dados.cmun_uf),
          cuf_sigla: data.dados.cuf_sigla,
        }

        // data.dados.pes_cpf_cnpj = data.dados.pes_cpf_cnpj.length === 11 ? maskCPF(data.dados.pes_cpf_cnpj) : maskCNPJ(data.dados.pes_cpf_cnpj);
        const cpfCnpjLimpo = limparCpfCnpj(data.dados.pes_cpf_cnpj);

        data.dados.pes_cpf_cnpj = /^[0-9]{11}$/.test(cpfCnpjLimpo)
          ? maskCPF(cpfCnpjLimpo)
          : maskCNPJ(cpfCnpjLimpo);


        data.dados.pes_limite_credito = data.dados.pes_data_limite_credito ? true : false;
        data.dados.pes_data_limite_credito = data.dados.pes_data_limite_credito ? moment(data.dados.pes_data_limite_credito, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';

        if (data.condPagtosSelect) {
          const condPagto = data.condPagtosSelect.map(regList => {
            return {
              key: String(regList.cp_idf),
              label: regList.cp_descricao,
            }
          });
          data.dados.condPagtosSelect = condPagto;
        }

        // console.log('data.condPagtosSelect: ', data.dados)

        this.setState({
          formVisivel: true,
          registroSelecionado: data.dados,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/pessoas/delete/${registro.pes_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.pes_idf === registro.pes_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        // pes_municipio: { key: '0' },

        pes_municipio: {
          key: String(this.state.usuario.emp_municipio),
          label: this.state.usuario.cmun_descricao,
          cmun_uf: String(this.state.usuario.cmun_uf),
          cuf_sigla: this.state.usuario.cuf_sigla,
        },
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/pessoas/ativa/${registro.pes_idf}/1`)
    } else {
      request = axios.put(`/pessoas/ativa/${registro.pes_idf}/0`)
    }

    request.then(response => {
      registro.pes_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderPFJ = (pes_cpf_cnpj) => {
    const value = limparCpfCnpj(pes_cpf_cnpj);

    return (
      <span>
        {/^[0-9]{11}$/.test(value) ? maskCPF(value) : maskCNPJ(value)}
      </span>
    );
  };


  renderAtiva = (pes_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={pes_situacao}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('ClientesPage', 'editar') ? false : true}
        style={{ backgroundColor: !pes_situacao ? null : Colors.primary }}
      />
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" disabled={getTemPermissao('ClientesPage', 'editar') ? false : true} size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" disabled={getTemPermissao('ClientesPage', 'excluir') ? false : true} size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite, busca } = this.state;

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Cadastro de Clientes</h2>
        <hr />
        <br />

        <div className="pageFiltro">
          {(!this.state.tipoUsuario) || (getTemPermissao('ClientesPage', 'novo')) ? (
            <Button
              onClick={this.onAdicionarClick}
              className="pageFiltro-adicionar"
            >
              Adicionar
            </Button>
          ) : null}

          <Search
            placeholder="Buscar por Nome"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <ClienteForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          // scroll={{ x: 600 }}
          rowKey={(registro => registro.pes_idf)}
        >
          <Column
            key="pes_codigo"
            dataIndex="pes_codigo"
            title="Código"
            width={"5%"}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="pes_nome"
            dataIndex="pes_nome"
            title="Nome"
            width={"15%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pes_razao_social"
            dataIndex="pes_razao_social"
            title="Razão Social"
            width={"15%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cmun_descricao"
            dataIndex="cmun_descricao"
            title="Cidade"
            width={"10%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cuf_sigla"
            dataIndex="cuf_sigla"
            title="UF"
            width={"5%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pes_cpf_cnpj"
            dataIndex="pes_cpf_cnpj"
            title="CPF/CNPJ"
            render={this.renderPFJ}
            width={"10%"}
            align="right"
            className="listaCadastro"
          />
          <Column
            key="pes_data_atu"
            dataIndex="pes_data_atu"
            title="Data Atu"
            render={this.renderData}
            width={"10%"}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="pes_situacao"
            dataIndex="pes_situacao"
            title="Situação"
            render={this.renderAtiva}
            width={"5%"}
            align="center"
            className="listaCadastro"
          />
          {getTemPermissao('GruposPage', 'editar') || getTemPermissao('GruposPage', 'excluir') ? (
            <Column
              key="acoes"
              title="Ações"
              render={this.renderAcoes}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
          ) : null}
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ClientesPage.js